module.exports = "img/create-big.950d607.png";